export default {
  // Tabs
  tabDisable: 'QR Code Disable',
  tabPageConfig: 'Disable Page Config',
  // Action bar
  addDisable: 'Add Disable',
  // Search
  batchCode: 'Batch Code',
  batchCodePlaceholder: 'Enter batch code',
  qrcode: 'QR Code',
  qrcodePlaceholder: 'Enter QR code',
  disableTime: 'Disable Time',
  startTime: 'Start Time',
  endTime: 'End Time',
  to: 'To',
  // Table columns
  colBatchSn: 'Batch',
  colQrcodeRange: 'QR Code Range',
  colQrcodeCount: 'QR Code Count',
  colForbidMessage: 'Forbid Reason',
  colCreatedAt: 'Disable Time',
  colAction: 'Action',
  // Actions
  releaseDisable: 'Release',
  edit: 'Edit',
  // Confirm release
  confirmReleaseTitle: 'Confirm Release',
  confirmReleaseContent: 'Are you sure to release this code?',
  // Add/Edit modal
  addDisableTitle: 'Add Disable',
  editDisableTitle: 'Edit Disable',
  batchCodeRequired: 'Please select a batch',
  batchSn: 'Batch',
  batchSnPlaceholder: 'Select QR code batch',
  forbidType: 'Forbid Type',
  forbidTypeAll: 'All',
  forbidTypePartial: 'Partial',
  startCode: 'Start Code',
  startCodePlaceholder: 'Enter start code',
  startCodeRequired: 'Please enter start code',
  endCode: 'End Code',
  endCodePlaceholder: 'Enter end code',
  endCodeRequired: 'Please enter end code',
  smallSerialStart: 'Small Serial Start',
  smallSerialStartPlaceholder: 'Enter small serial start',
  smallSerialEnd: 'Small Serial End',
  smallSerialEndPlaceholder: 'Enter small serial end',
  forbidMessage: 'Forbid Message',
  forbidMessagePlaceholder: 'Enter forbid message',
  forbidMessageRequired: 'Please enter forbid message',
  remark: 'Remark',
  remarkPlaceholder: 'Enter remark',
  // Empty state
  emptyText: 'No disable records',
  // Disable page config
  pageTitle: 'Page Title',
  pageTitleRequired: 'Please enter at least one language title',
  tipImage: 'Tip Image',
  textColor: 'Text Color',
  bgColor: 'Background Color',
  resetDefaultImage: 'Reset Default Image',
  resetDefaultColor: 'Reset Default Color',
  defaultPreviewTitle: 'QR Code Error',
  defaultTipImage: 'Disabled Image',
  defaultTipText: 'This QR code has been disabled. Please contact support.',
};
